import {
  axiosInstance,
  AI_TUTOR_URL,
  TEST_GET_URL,
  TEST_SUBMIT_URL,
  QUIZ_SUBMIT_URL,
  QUIZ_RESULT_GET_URL,
  GET_INITIAL_TEST,
  GET_ALL_INITIAL_TEST,
  AI_GENERATE_TEST_URL,
  QUESTION_BANK_COMPLETE_SUBMIT_URL,
  QUESTION_BANK_INSTITUTION_COMPLETE_SUBMIT_URL,
  REATTEMPT_TEST_URL,
} from "../apiurls/apiurls";
import { api } from "../apiurls/apiurls";

export const getInitialOnboardingTest = async (courseKey) => {
  try {
    const response = await axiosInstance.get(
      `${GET_ALL_INITIAL_TEST}?course_key=${courseKey}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching onboarding test:", error);
    throw error;
  }
};

export const getInitialTestById = async (testId) => {
  try {
    const response = await axiosInstance.get(
      `${GET_INITIAL_TEST}?id=${testId}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching test by ID:", error);
    throw error;
  }
};

export const getTestData = async (params = {}) => {
  try {
    const response = await axiosInstance.get(TEST_GET_URL, { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching onboarding test:", error);
    throw error;
  }
};

export const sendAiTutorData = async (payload, meta = {}) => {
  const { testPageId, title, key, regenerate } = meta;

  const params = new URLSearchParams();
  if (testPageId) params.set("test_page_content_id", testPageId);
  if (title) params.set("title", title);
  if (key) params.set("key", key);
  if (regenerate) params.set("regenerate", "true");

  const url = params.toString()
    ? `${AI_TUTOR_URL}?${params.toString()}`
    : AI_TUTOR_URL;

  try {
    const response = await axiosInstance.post(url, payload);
    return response.data;
  } catch (error) {
    console.error("Error sending AI Tutor data:", error);
    return null;
  }
};

export const submitInitialResults = async (payload) => {
  try {
    const response = await axiosInstance.post(
      "/api/initial-results/submit",
      payload
    );
    return response.data;
  } catch (error) {
    console.error("Error submitting initial onboarding test results:", error);
    throw error;
  }
};

export const submitTestResults = async (payload, meta = {}) => {
  const { testPageId, title, key } = meta;

  const params = new URLSearchParams();
  if (testPageId) params.set("test_page_content_id", testPageId);
  if (title) params.set("title", title);
  if (key) params.set("key", key);

  const url = params.toString()
    ? `${TEST_SUBMIT_URL}?${params.toString()}`
    : TEST_SUBMIT_URL;

  try {
    const response = await axiosInstance.post(url, payload);
    return response.data;
  } catch (error) {
    console.error("Error submitting test results:", error);
    throw error;
  }
};

export const submitQuizResults = async (payload, meta = {}) => {
  const { quizPageId, title, key, parent } = meta;

  const params = new URLSearchParams();
  if (quizPageId) params.set("quiz_page_content_id", quizPageId);
  if (title) params.set("title", title);
  if (key) params.set("key", key);
  if (parent) params.set("parent", parent);

  const url = params.toString()
    ? `${QUIZ_SUBMIT_URL}?${params.toString()}`
    : QUIZ_SUBMIT_URL;

  try {
    const response = await axiosInstance.post(url, payload);
    return response.data;
  } catch (error) {
    console.error("Error submitting quiz results:", error);
    throw error;
  }
};

export const getQuizResult = async (params = {}) => {
  try {
    const response = await axiosInstance.get(QUIZ_RESULT_GET_URL, { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching quiz result:", error);
    throw error;
  }
};

export const generateAiTest = async (payload) => {
  try {
    const response = await api.socket(AI_GENERATE_TEST_URL, payload);
    return response;
  } catch (error) {
    console.error("Error generating AI test:", error);
    throw error;
  }
};

export const submitQuestionBankComplete = async (payload) => {
  try {
    const response = await axiosInstance.post(
      QUESTION_BANK_COMPLETE_SUBMIT_URL,
      payload
    );
    return response.data;
  } catch (error) {
    console.error("Error submitting question bank completion:", error);
    throw error;
  }
};

export const submitQuestionBankInstitutionComplete = async (payload) => {
  try {
    const response = await axiosInstance.post(
      QUESTION_BANK_INSTITUTION_COMPLETE_SUBMIT_URL,
      payload
    );
    return response.data;
  } catch (error) {
    console.error("Error submitting question bank institution completion:", error);
    throw error;
  }
};

export const reattemptTest = async (reattemptPayload, meta = {}) => {
  const { testPageId, title, key } = meta;

  const params = new URLSearchParams();
  if (testPageId) params.set("test_page_content_id", testPageId);
  if (title) params.set("title", title);
  if (key) params.set("key", key);

  const url = params.toString()
    ? `${REATTEMPT_TEST_URL}?${params.toString()}`
    : REATTEMPT_TEST_URL;

  try {
    const response = await axiosInstance.post(
      url,
      reattemptPayload
    );
    return response.data;
  } catch (error) {
    console.error("Error reattempting test:", error);
    throw error;
  }
};
